import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { articles, talks } from '../../data/writing';
import { profile } from '../../data/profile';
export function Writing() {
  return <section id="writing" className="mt-28 scroll-mt-24 lg:scroll-mt-10" data-id="element-466" data-mp="3obec9p8jsklc">
      <SectionHeading index="02" label="Writing & talks" title="Designing for real minds" description="I write about psychology and product design for everyone, from founders to designers." data-id="element-467" data-mp="3o9bgspomlz98" />

      <ul className="mt-8 border-t border-line" data-id="element-468" data-mp="fvcllq9hahws">
        {articles.map(article => <li key={article.title} className="border-b border-line" data-id="element-469" data-mp="awi3kqjc4xdq">
            <a href={article.href} target="_blank" rel="noreferrer" className="group grid gap-1 py-5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink/30 sm:grid-cols-[96px_1fr_auto] sm:gap-6" data-id="element-470" data-mp="aw9t15aoq45p">
              <span className="pt-0.5 text-xs tabular-nums text-fg-faint" data-id="element-471" data-mp="2zf2dw21rjdgy">{article.date}</span>
              <span data-id="element-472" data-mp="33eum2dn8vhls">
                <span className="block text-[15px] font-semibold text-fg transition-colors duration-150 group-hover:text-ink" data-id="element-473" data-mp="33e1qm8tqkeiy">
                  {article.title}
                </span>
                <span className="mt-1 block text-sm leading-relaxed text-fg-muted" data-id="element-474" data-mp="2udwjlzsgfi5b">{article.excerpt}</span>
              </span>
              <ArrowUpRightIcon className="hidden h-4 w-4 text-fg-faint transition-[transform,color] duration-200 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-ink sm:block" data-id="element-475" data-mp="2foqkebtm9rxf" />
            </a>
          </li>)}
      </ul>

      <div className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-476" data-mp="2bprhewrg458m">
        {talks.map((talk, i) => <Reveal key={talk.title} delay={i * 0.05} className="h-full" data-id="element-477" data-mp="1wt0i0nhrutj0" data-mpi={i}>
            <article className="flex h-full flex-col rounded-2xl bg-ink p-6 text-white" data-id="element-478" data-mp="21rbqatsf4vz4">
              <p className="text-xs text-white/70" data-id="element-479" data-mp="1ilx9jqzsrngy">
                {talk.when} · {talk.event}
              </p>
              <h3 className="mt-3 text-base font-semibold leading-snug" data-id="element-480" data-mp="1dv72m9bq3ck5">{talk.title}</h3>
              <p className="mt-auto pt-4 text-sm leading-relaxed text-white/75" data-id="element-481" data-mp="18vugxrwl8bj5">{talk.description}</p>
            </article>
          </Reveal>)}
      </div>

      <a href={profile.medium} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-ink underline decoration-ink/30 underline-offset-4 transition-colors duration-150 hover:decoration-ink" data-id="element-482" data-mp="13v6gygqdskcs">
        All articles on Medium
        <ArrowUpRightIcon className="h-4 w-4" data-id="element-483" data-mp="1roojfmd0yb6h" />
      </a>
    </section>;
}